import Vue from 'vue';
import { cloneDeep } from 'lodash';
// import moment from 'moment';

const INIT_APPTYPE = {
  filterdIdList: [],
  selectedRepIdList: [],

  currentPage: 1,
  perPage: 10,
  totalRows: 0,
  // フィルタリング条件保存
  search: {
    name: '',
    series: null,
    year: null,
    code: '',
    status: '',
    // No.23 §16：表示対象（report=報告／survey=アンケート）
    mode: 'report',
    // No.23 §16-9：回答状況（answered=回答あり〔既定〕／unanswered=未回答／all=すべて）
    answered: 'answered',
  },
  // No.15: 画面戻り時のソート維持
  sortBy: 'kana',
  sortDesc: false,
};

export default {
  namespaced: true,
  state: cloneDeep(INIT_APPTYPE),
  mutations: {
    setFilter(state, param) {
      Vue.set(state.search, param.key, param.value);
      // No.15: 検索条件変更時はデフォルトソート(kana 昇順)に戻す
      state.sortBy = 'kana';
      state.sortDesc = false;
    },
    // No.23 §16：表示対象の切替。母集合が変わるため選択（チェック）は必ずクリアする。
    // 報告モード専用のステータス絞り込みも合わせてリセットする。
    setMode(state, mode) {
      Vue.set(state.search, 'mode', mode);
      Vue.set(state.search, 'status', '');
      // 回答状況も既定（回答あり）へ戻す
      Vue.set(state.search, 'answered', 'answered');
      state.selectedRepIdList = [];
      state.currentPage = 1;
      state.sortBy = 'kana';
      state.sortDesc = false;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    setPerPage(state, page) {
      state.perPage = page;
    },
    setTotalRows(state, value) {
      state.totalRows = value;
    },
    initFilter(state) {
      Vue.set(state.search, 'name', '');
      Vue.set(state.search, 'series', null);
      Vue.set(state.search, 'year', null);
      Vue.set(state.search, 'code', '');
      Vue.set(state.search, 'status', '');
      // No.23 §16：ヘッダー経由のリセットでは表示対象・回答状況も既定へ戻す
      Vue.set(state.search, 'mode', 'report');
      Vue.set(state.search, 'answered', 'answered');
      state.currentPage = 1;
      state.perPage = 10;
      state.totalRows = 0;
      // No.15: ヘッダー経由リセット時もデフォルトソート(kana 昇順)に戻す
      state.sortBy = 'kana';
      state.sortDesc = false;
    },
    setSortBy(state, v) {
      state.sortBy = v;
    },
    setSortDesc(state, v) {
      state.sortDesc = v;
    },
    setSort(state, { sortBy, sortDesc }) {
      state.sortBy = sortBy;
      state.sortDesc = sortDesc;
    },
    setFilterdIdList(state, filterdData) {
      const filterdIdList = filterdData.map((data) => {
        return data.id;
      });
      state.filterdIdList = filterdIdList;
    },
    removeSelectedAppid(state, repId) {
      const index = state.selectedRepIdList.indexOf(repId);
      if (index !== -1) {
        state.selectedRepIdList.splice(index, 1);
      }
    },
    addSelectedAppid(state, repId) {
      if (state.selectedRepIdList.indexOf(repId) === -1) {
        state.selectedRepIdList.push(repId);
      }
    },
    allSelectedAppid(state) {
      state.selectedRepIdList = state.filterdIdList.slice();
    },
    initSelectedAppid(state) {
      state.selectedRepIdList = [];
    },
  },
  actions: {
  },
};
